export default "__VITE_ASSET__Cctz1khQ__"